"use strict";
/**
 * Component: AppProgress.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var core_1 = require("@material-ui/core");

var AppProgress = function AppProgress(props) {
  if (!props.appState || !props.appState.loadState.isLoading || !props.appState.pantState.hasHeader) {
    return null;
  }

  var top = props.appState.pantState.headerHeight - 2;
  return React.createElement("div", {
    style: __assign({
      position: 'fixed',
      top: top,
      left: 0,
      zIndex: 1400,
      width: '100%'
    }, props.style)
  }, React.createElement(core_1.LinearProgress, {
    variant: "indeterminate",
    color: "secondary",
    style: {
      height: 2
    }
  }));
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(AppProgress));